export default "__VITE_ASSET___w3QRWd9__"